export default __webpack_public_path__ + "static/media/silka-semibold-webfont.4309dd97.woff2";